import { Directive } from '@angular/core';

@Directive({
  selector: '[treeCustomNodeDef]'
})
export class TreeCustomNodeDefDirective {}
